import * as React from 'react';
import './Sorter.scss';
import { FunctionComponent } from 'react';
import { Tooltip } from '@iba-team/portal-react-components/dist';

export interface SorterProps {
  text: string,
  sortOrder: number,
}

const Sorter: FunctionComponent<SorterProps> = (props) => {

  let tooltipTitle = 'Click to sort ascending';
  if (props.sortOrder > 0) {
    tooltipTitle = 'Click to sort descending';
  } else if (props.sortOrder < 0) {
    tooltipTitle = 'Click to cancel sorting';
  }

  return (
    <Tooltip title={tooltipTitle}>
      <div className='sorter'>
        <span className='sorter__text'>{props.text}</span>
        <div className='sorter__arrows'>
          <div className={`sorter__arrow sorter__arrow_up ${props.sortOrder > 0 ? 'sorter__arrow_up_selected' : ''}`}></div>
          <div className={`sorter__arrow sorter__arrow_down ${props.sortOrder < 0 ? 'sorter__arrow_down_selected' : ''}`}></div>
        </div>
      </div>
    </Tooltip>
  );
};

export default Sorter;